import { inject, Injectable } from '@angular/core';
import { HttpGatewayService } from '../../../core/services/http-gateway.service';
import { Observable } from 'rxjs';
import { CityData } from '../types/city-data';

const CITY_URLS = {
    GET_CITIES: 'api/v5/load-cities',
};

@Injectable({ providedIn: 'root' })
export class CityService {
    private http = inject(HttpGatewayService);

    public getCities(userInput: string): Observable<CityData[]> {
        return this.http.post(
            CITY_URLS.GET_CITIES,
            { userInput },
        );
    }
}
